<template>
  <div class="iv-contact-twin iv-p-t-40 iv-p-b-40">
    <!-- 结对子员工 -->
    <div class="iv-main-width">
      <Tab v-model="tabName" :navList="navList" @on-click="tabClick"></Tab>
      <div class="iv-contact-twin-content">
        <DragTable
          noSearch
          class="iv-m-t-24"
          :showSelect="false" 
          ref="DragTable" 
          :immediateForce="true" 
          :columns="column"
          :showDelete="false"
          :showEdit="false"
          :showPage="false"
          :tableData="tableData">
        </DragTable>
      </div>
    </div>
    <FooterOperator>
      <div class="iv-text-center">
        <Button type="save" @click="save">保存</Button>
        <Button type="back" class="iv-m-l-16" @click="back">返回</Button>
      </div>
    </FooterOperator>
  </div>
</template>

<script>
import Tab from '@/components/tab'
import { twinColumn, infoColumn } from './column'
import DragTable from '@/components/drag-table-inline'
import FooterOperator from '@/components/footer-operator'

export default {
  data () {
    return {
      tabName: 'SBZT01',
      tableData: [{}]
    }
  },
  created () {
    this.init()
    this.column = twinColumn.call(this)
  },
  provide () {
    return {
      expandParent: this.expandParent
    }
  },
  methods: {
    //行内点击
    expandParent (type, item) {},
    //保存
    save () {},
    tabClick (name) {
      this.tabName = name
      if (this.tabName == 'SBZT02') {
        this.tableData = []
        this.column = infoColumn.call(this)
      } else {
        this.tableData = []
        this.column = twinColumn.call(this)
      }
    },
    //返回
    back () {
      this.$router.go(-1)
    },
    init () {
      this.navList = [{
        label: '结对子员工',
        name: 'SBZT01'
      }, {
        label: '信息阅读情况',
        name: 'SBZT02'
      }]
    }
  },
  components: {
    Tab,
    DragTable,
    FooterOperator
  }
}
</script>

<style lang="scss" scoped>
.iv-contact-twin {
  min-height: 100%;
  background-color: #fff;
}
</style>